import type {
	AddressSuggestion,
	AutocompleteResult,
	ValuesType,
	ZipCodeLookupResult,
} from "@server/actions/smarty-utils";

export type {
	AddressSuggestion,
	AutocompleteResult,
	ValuesType,
	ZipCodeLookupResult,
};

export {
	checkValidityOfFormValuesAgainstInput,
	formatAutocompleteSuggestion,
} from "@server/actions/smarty-utils";

const SMARTY_API_PATH = "/api/smarty";

async function callSmartyApi<T>(body: object): Promise<T> {
	const response = await fetch(SMARTY_API_PATH, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	});

	if (!response.ok) {
		throw new Error(`Smarty API request failed: ${response.status}`);
	}

	return (await response.json()) as T;
}

export async function autocompleteAddress(
	search: string,
	selectedZipCode?: string,
	maxResults = 10,
	selected?: string,
): Promise<AutocompleteResult> {
	try {
		return await callSmartyApi<AutocompleteResult>({
			action: "autocompleteAddress",
			search,
			selectedZipCode,
			maxResults,
			selected,
		});
	} catch {
		return {
			suggestions: [],
			error: "An error occurred processing your request",
		};
	}
}

export async function lookupZipCode(
	zipCode: string,
): Promise<ZipCodeLookupResult> {
	try {
		return await callSmartyApi<ZipCodeLookupResult>({
			action: "lookupZipCode",
			zipCode,
		});
	} catch {
		return {
			city: "",
			state: "",
			zipCode,
			zipCodeValid: undefined,
			error: "An error occurred processing your request",
		};
	}
}
